import { render } from "./ExposomexView.vue?vue&type=template&id=28e946e1&scoped=true"
import script from "./ExposomexView.vue?vue&type=script&lang=js"
export * from "./ExposomexView.vue?vue&type=script&lang=js"

import "./ExposomexView.vue?vue&type=style&index=0&id=28e946e1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e946e1"]])

export default __exports__